import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SiteLayout from "@/components/SiteLayout";
import PageMeta from "@/components/PageMeta";
import { api } from "@/lib/api";

function formatDate(iso) {
  try { return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" }); } catch { return ""; }
}

export default function InsightDetail() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api.get(`/insights/${slug}`).then((r) => setItem(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <SiteLayout>
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-32">
          <h1 className="h-display text-4xl">Insight not found.</h1>
          <Link to="/insights" className="link-grow mt-6 inline-flex">Back to Insights</Link>
        </div>
      </SiteLayout>
    );
  }

  if (!item) return <SiteLayout><div /></SiteLayout>;

  return (
    <SiteLayout>
      <PageMeta
        title={`${item.title} | Insights`}
        description={item.subtitle || item.title}
        image={item.cover_image}
        type="article"
      />
      <article className="max-w-3xl mx-auto px-6 md:px-10 pt-10 md:pt-20" data-testid="insight-detail">
        <Link to="/insights" className="inline-flex items-center gap-2 overline text-graphite/60 hover:text-[#1E3668]">
          <ArrowLeft size={14} /> All insights
        </Link>

        <p className="text-xs text-graphite/55 mt-12">
          {formatDate(item.published_at || item.created_at)} · <span className="text-[#1E3668]">{item.category}</span>
        </p>
        <h1 className="mt-6 h-display text-[clamp(2.2rem,5.5vw,4.6rem)]" data-testid="insight-title">{item.title}</h1>
        {item.subtitle && <p className="mt-6 text-xl md:text-2xl text-graphite/85 leading-snug max-w-3xl">{item.subtitle}</p>}
        {item.cover_image && (
          <img src={item.cover_image} alt={item.title} className="mt-10 w-full max-h-[520px] object-cover bw-portrait" />
        )}
        <hr className="my-12 border-graphite/15" />
        <div
          className="text-lg leading-[1.85] text-graphite/90 prose prose-cec [&_p]:mb-5 [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-2xl [&_h2]:font-semibold"
          data-testid="insight-body"
          dangerouslySetInnerHTML={{ __html: item.body || "" }}
        />
        <p className="mt-16 text-xs text-graphite/55">Written by · {item.author}</p>
      </article>
    </SiteLayout>
  );
}
